import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { FIRESTORE_TOKEN, FirestoreProvider } from '@core';
import { IntroductionCompletion } from '../../application/models';

type LegacyViewedField = string[] | { _methodName: string; vc: string[] } | undefined;

interface LegacyIntroductionDocument {
  readonly viewed: LegacyViewedField;
}

const INTRODUCTION_V2_COLLECTION: string = 'introduction-v2';
const LEGACY_INTRODUCTION_COLLECTION: string = 'introduction';

export class IntroductionV2Service {
  private readonly firestoreProvider: FirestoreProvider = inject(FIRESTORE_TOKEN);

  isCompleted(userId: string): Observable<boolean> {
    return this.firestoreProvider
      .documentSnapshot<IntroductionCompletion>(INTRODUCTION_V2_COLLECTION, userId)
      .pipe(map((data: IntroductionCompletion) => !!data?.completedAt));
  }

  hasLegacyIntroduction(userId: string): Observable<boolean> {
    return this.firestoreProvider
      .documentSnapshot<LegacyIntroductionDocument>(LEGACY_INTRODUCTION_COLLECTION, userId)
      .pipe(map((data: LegacyIntroductionDocument) => this.readLegacyViewed(data?.viewed).length > 0));
  }

  complete(userId: string, completion: IntroductionCompletion): Promise<void> {
    return this.firestoreProvider.updateDocument(INTRODUCTION_V2_COLLECTION, userId, { ...completion });
  }

  private readLegacyViewed(viewed: LegacyViewedField): string[] {
    if (Array.isArray(viewed)) return viewed;

    if (viewed && typeof viewed === 'object' && 'vc' in viewed && Array.isArray(viewed.vc)) {
      return viewed.vc;
    }

    return [];
  }
}
